module.exports = __webpack_public_path__ + "static/img/icon-kcc-portal.6b9619ff.svg";